import React from 'react';
export default function UnsupportedBrowserWarning({ children }: { children: React.ReactElement }) {
  return children;
}
